<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-text-field v-if="entry.importItemName"
          v-model="entry.importItemName"
          v-bind="getObject('importItemName')"
          label="Nome do item na nota"
          readonly
          autocomplete="off"
          @input="importItem"
        />
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          ref="myItemSearch"
          :items="purchaseItemsList"
          item-value="id"
          item-text="name"
          :search-input.sync="itemsSearch"
          no-filter
          @input="selectItem(true)"
          no-data-text="Nenhum Item encontrado, faça outra busca"
          :hint="purchaseItemAdditionalInfo(entry.item)"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{purchaseItemAdditionalInfo(data.item)}} </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template v-slot:append-outer>
            <NewItemSelect
              ref="newItemSelect"
              newTitle="Adicionar Item"
              width="50%"
              openSelectButtonLabel="Adicionar Item"
              :inlineAddButton="true"
              @entry-created="itemCreated"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          :disabled="!entry.itemId || readOnly"
          v-model="entry.packagingId"
          v-bind="getObject('packagingId')"
          label="Embalagem"
          :items="packagingList"
          item-value="id"
          item-text="name"
          @input="selectPackaging"
          :loading="packagingListLoading"
          autocomplete="off"
        >
          <!-- <template v-slot:append-outer>
            <PackagingNew
              :inlineAddButton="true"
              @entry-created="packagingCreated"
            />
          </template> -->
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.storageId"
          v-bind="getObject('storageId')"
          label="Estoque"
          :items="extraData.accountContext.allStorages"
          item-value="id"
          item-text="name"
          @input="selectStorage"
          :hint="entry.storage ? 'Localização: ' + (entry.storage.location ? entry.storage.location : 'não informada') : '' "
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>Localização: {{data.item.location ? data.item.location : 'não informada'}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template v-slot:append-outer>
            <StorageNew
              :inlineAddButton="true"
              @entry-created="storageCreated"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" v-if="entry.enabledLots">
        <v-switch 
          v-model="entry.hasLot" 
          inset 
          :label="entry.hasLot ? 'Informar lote' : 'Sem informar lote'"
          :disabled="readOnly">
        </v-switch>
      </v-col>

      <v-col cols="12" v-if="entry.enabledLots && entry.hasLot">
        <DummyEntryMovementItemLotsIndex
          :lotItems="entry.dummyEntryMovementItemLotsAttributes"
          :packaging="entry.packaging"
          :inputData.sync="entry.dummyEntryMovementItemLotsAttributes"
          @update:inputData="addLots"
          :readOnly="readOnly"          
          :hasTableTitle="true"
          :addAndEdit="true"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="entry.packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"
          :disabled="!entry.packagingId || readOnly || entry.hasLot"
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :suffix="entry.packaging ? entry.packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantity'"
        />
        <!--   -->
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade Unitária"
          :disabled="!entry.packagingId || readOnly || entry.hasLot"
          @update:inputData="changeQuantity"
          autocomplete="off"
          :suffix="entry.item ? entry.item.unit.name : ''"
          :key="quantityKey + 'quantity'"
        />
        <!-- -->
      </v-col>

       <!-- Preço da embalagem -->
      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="entry.packagingPrice"
          mask-type="currency_10d"
          label="Preço Embalagem"
          prefix="R$"
          :suffix="entry.packaging ? entry.packaging.text : ''"
          :disabled="!entry.packagingId || readOnly"
          :key="packagingPriceKey + 'packagingPrice'"
          @update:inputData="changePackagingPrice"
          autocomplete="off"
        />
      </v-col>

      <!-- preço unitario -->
      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('unitPrice')"
          :inputData.sync="entry.unitPrice"
          mask-type="currency_10d"
          label="Preço Unitário"
          prefix="R$"
          :suffix="entry.item ? entry.item.unit.name : ''"
          :disabled="!entry.packagingId || readOnly"
          :key="unitPriceKey + 'unitPrice'"
          @update:inputData="changeUnitPrice"
          autocomplete="off"
        />
      </v-col>

      <!-- preço total -->
      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('price')"
          :inputData.sync="entry.price"
          mask-type="currency"
          label="Preço Total"
          prefix="R$"
          :disabled="!entry.packagingId || readOnly"
          :key="totalPriceKey + 'price'"
          @update:inputData="changeTotalPrice"
          autocomplete="off"
        />
      </v-col>      
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import PackagingNew from "@models/packagings/new.vue"
import StorageNew from "@models/storages/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
import NewItemSelect from "./new_item_select.vue"
import DummyEntryMovementItemLotsIndex from "@models/manufacturing_lots/item_lots/index.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      purchaseItemsList: [],
      purchaseItemsListLoading: false,
      packagingListLoading: false,
      packagingList: [],
      renderComponent: true,
      itemsSearch: "",
      unitPriceKey: 0,
      totalPriceKey: 0,      
      packagingQuantityKey: 0,
      quantityKey: 0,
      packagingPriceKey: 0,
      pageLoading: false,
      timer: null,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,    
  },
  components: {
    MaskedTextField: MaskedTextField,    
    StorageNew: StorageNew,
    BaseUtil: BaseUtil,
    NewItemSelect: NewItemSelect,
    DummyEntryMovementItemLotsIndex: DummyEntryMovementItemLotsIndex,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("item purchase", this.entry.item)    
    if (this.entry.item) {
      this.purchaseItemsList = [this.entry.item];
      this.selectItem(false);
      this.changeQuantity();
    }
  },
  mounted() {
    console.log("import name");
    if(this.importItemName){
      this.itemsSearch = this.importItemName;
    }

    this.$nextTick(() => {
      // this.$refs.myItemSearch.value = this.importItemName;
      this.$refs.myItemSearch.focus();
      this.searchItemsFunction(this.importItemName, "");
    });
  },
  computed: {
    // itemTotalPrice: function() {
    //   this.entry.totalPrice = _.round((this.entry.price ? this.entry.price : 0) * (this.entry.quantity ? this.entry.quantity : 0), 2);
    //   return this.entry.totalPrice;
    // }
  },
  watch: {
    itemsSearch: {
      handler: function(newSearch, oldSearch) {
        // console.log("newSearch", newSearch, "oldSearch", oldSearch)
        this.searchItemsFunction(newSearch, oldSearch);
      },
      immediate: true,
    },
    "entry.dummyEntryMovementItemLotsAttributes": {
      handler: function(newValue, oldValue) {
        if(this.entry.enabledLots){
          // console.log("entry edited !!!");
          this.addLots();
        }
      },
      deep: true,
    },
    "entry.importItemName": {
      handler: function(newValue, oldValue){
        console.log("trocou import name");
      },
      deep: true,
    },
  },
  methods: {
    searchItemsFunction(newSearch, oldSearch){
      if(this.importItemName){
          this.itemsSearch == this.importItemName;
        }
        if (this.itemsSearch && this.itemsSearch.length > 0) {
          if ((!this.entry.item || this.entry.item.name != this.itemsSearch) && newSearch.length >= 3) {
            if(this.timer){
              clearTimeout(this.timer);
            }
            this.timer = setTimeout( ()=> {
              // console.log("newSearch", newSearch);
              this.getPurchaseItems();
            }, 1000);
          }
        }
      },
    importItem: function(){
      console.log("import item");
    },
    purchaseItemAdditionalInfo: function(item) {
      let info = ""
      if (item) {
        info = 'Unidade de Compra: ' + item.unit.name + (item.brand ? ', Marca: ' + item.brand.name : '') + (item.typeText ? ', Tipo: ' + item.typeText : '')
      }
      return info;
    },
    addLots: function(){
      // console.log("addLots");
      var reduced = 0;
      this.entry.dummyEntryMovementItemLotsAttributes.forEach((object)=>{
        // console.log("packaging quantity:", object.packagingQuantity);        
        // console.log("bool", (typeof object._destroy == 'undefined' || object._destroy == false));
        if (typeof object._destroy == 'undefined' || object._destroy == false){
          reduced+=parseFloat(object.packagingQuantity);
        }
        // return parseInt(accumulator) + (typeof object._destroy == 'undefined' || object._destroy == false) ? parseInt(object.packagingQuantity) : 0;
      });
      // console.log(reduced);
      this.entry.packagingQuantity = reduced;
      this.packagingQuantityKey++;
      this.changePackagingQuantity();
    },
    changeQuantity: function() {
      this.entry.packagingQuantity = _.round(this.entry.quantity / this.entry.packaging.size, 10);
      this.packagingQuantityKey++;
      this.updateQuantity();
    },
    updateQuantity: function() {
      if (this.entry.unitPrice > 0) {
        this.calculatePackagingPrice();
        this.calculateTotalPrice();
      } else if (this.entry.price > 0) {
        this.calculateUnitPrice();
        this.calculatePackagingPrice();
      } else {
        this.entry.price = 0;
        this.totalPriceKey++;
        this.entry.unitPrice = 0;
        this.unitPriceKey++;
        this.entry.packagingPrice = 0;
        this.packagingPriceKey++;
      }
    },
    changePackagingQuantity: function() {
      this.entry.quantity = _.round(this.entry.packagingQuantity * this.entry.packaging.size, 10);
      this.quantityKey++;
      this.updateQuantity();
    },
    changeUnitPrice: function() {
      if (this.entry.quantity > 0) {
        this.calculatePackagingPrice();
        this.calculateTotalPrice();
      }
    },
    changePackagingPrice: function() {
      if (this.entry.quantity > 0) {
        this.calculateUnitPrice(false);
        this.calculateTotalPrice();
      }
    },
    changeTotalPrice: function() {
      if (this.entry.quantity > 0) {
        this.calculateUnitPrice();
        this.calculatePackagingPrice();
      }
    },
    calculateTotalPrice: function() {
      this.entry.price = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.entry.quantity ? this.entry.quantity : 0), 2);
      this.totalPriceKey++;
    },
    calculateUnitPrice: function(byTotalPrice=true) {
      if (byTotalPrice) {
        this.entry.unitPrice = _.round((this.entry.price ? this.entry.price : 0) / (this.entry.quantity ? this.entry.quantity : 0), 10);
      } else { //calcula pelo preco unitario com base no preco da embalagem
        this.entry.unitPrice = _.round((this.entry.packagingPrice ? this.entry.packagingPrice : 0) / (this.entry.packaging.size ? this.entry.packaging.size : 0), 10);
      }
      this.unitPriceKey++;
    },
    calculatePackagingPrice: function() {
      this.entry.packagingPrice = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.entry.packaging.size ? this.entry.packaging.size : 0), 10);
      this.packagingPriceKey++;
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    getPurchaseItems: function() {
      this.purchaseItemsListLoading = true;
      this.$apollo
        .query({
          query: ITEMS_FOR_PURCHASE_QUERY,
          variables: {
            query: this.itemsSearch
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.purchaseItemsList = response.data.accountGlobalSharedContext.allAvailableItemsForPurchase;
          console.log("getPurchaseItems", this.purchaseItemsList);
          // if (this.packageList.length == 1 && !this.entry.packageId) {
          //   this.entry.packageId = this.packageList[0].id;
          //   this.selectPackage();
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.purchaseItemsListLoading = false));
    },
    selectItem: function(clearPackaging, newPackaging=null) {
      this.entry.item = this.purchaseItemsList.find(obj => obj.id == this.entry.itemId);

      // console.log("item, itemID", this.entry.item, this.entry.itemId)

      // this.clearFields();
      if (clearPackaging) {
        this.entry.packagingId = null;
        //TODO rever como remover os item lots aqui, tem campo novo agora pra verificar se foi gerado automatico, neste caso ai nao remover !!!
        // while(this.entry.dummyEntryMovementItemLotsAttributes?.length > 0){
        console.log("dummys", this.entry.dummyEntryMovementItemLotsAttributes);
        this.entry.dummyEntryMovementItemLotsAttributes = this.entry.dummyEntryMovementItemLotsAttributes.filter(item => item.generated);
          // this.entry.dummyEntryMovementItemLotsAttributes.pop();
        // }
      }
      this.packagingListLoading = true;
      this.$apollo
        .query({
          query: PACKAGINGS_FOR_ITEM_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId
          }
        })
        .then(response => {
          this.packagingList = response.data.accountGlobalSharedContext.allPackagingsOfItem;

          // console.log("this.packagingList",this.packagingList);

          if (newPackaging) {
            let result_find = this.packagingList.find(obj => obj.id == newPackaging.id);
            if (result_find) {
              this.entry.packagingId = newPackaging.id;
              this.entry.packaging = newPackaging;
              // this.selectPackaging();
            } else {
              this.$refs.util.showErrorMessage("A embalagem criada não é compatível com o item selecionado, por isso não irá aparecer na lista de embalagens!");
            }
          } else if (this.packagingList.length == 1 && !this.entry.packagingId) {
            this.entry.packagingId = this.packagingList[0].id;
            this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);
            // this.selectPackage();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingListLoading = false));
    },
    selectPackaging: function() {
      // console.log("packaging", this.entry);
      this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);

      this.entry.packagingQuantity = 0;
      this.changePackagingQuantity();
      // return;
      // this.entryAttributes.quantity.rules = [];
      // this.entryAttributes.quantity.rules.push(this.requiredRule);
      // this.entryAttributes.quantity.rules.push(this.minRequiredRule);
      // // this.entryAttributes.quantity.rules.push(this.maxValueRule(this.entry.storehouse.availableQuantity));

      // this.entryAttributes.price.rules = [];
      // this.entryAttributes.price.rules.push(this.requiredRule);
      // this.entryAttributes.price.rules.push(this.minRequiredRule);
      // this.clearFields();
    },
    selectStorage: function() {
      this.entry.storage = this.extraData.accountContext.allStorages.find(obj => obj.id == this.entry.storageId);
    },
    clearFields: function() {
      this.forceRerender(this);
    },
    packagingCreated: function(packaging) {
      this.selectItem(true, packaging);
    },
    storageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.storageId = storage.id;
      this.entry.storage = storage;
    },
    itemCreated: function(item) {
      // console.log("item created", item)
      this.purchaseItemsList.unshift(item);
      this.entry.itemId = item.id;
      this.entry.item = item;
      this.selectItem(true);
    },
  }
};

const ITEMS_FOR_PURCHASE_QUERY = gql `
  query ($query: String!) {
    accountGlobalSharedContext {
      allAvailableItemsForPurchase(query: $query) {
        id
        name
        unit {
          name
        }
        brand {
          name
        }
        typeText
      }
    }
  }
`;

const PACKAGINGS_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!) {
    accountGlobalSharedContext {
      allPackagingsOfItem(itemId: $itemId) {
        id
        name
        unitName
        size
        text
      }
    }
  }
`;

</script>

<style scoped></style>
